import React, { useEffect } from 'react';
import FormModal from '../../Modals/FormModal';
import { useEnabledDocumentTypes } from '../../../hooks/dte/useEnabledDocumentTypes';
import SelectField from '../../Forms/Input/SelectField';
import { useDocumentType } from '../../../hooks/useDocumentType';
import { HelpCircle, Info } from 'lucide-react';
import SectionInfoHeader from '../../common/SectionInfoHeader';

interface Props {
  isOpen: boolean;
  close: () => void;
}

const EnabledDocumentTypePopup: React.FC<Props> = ({ isOpen, close }) => {
  const {
    form,
    formErrors,
    isSubmit,
    updateField,
    saveDocument,
    cleanFormErrors,
  } = useEnabledDocumentTypes();

  const { documentTypeDropdown, fetchDocumentTypeDropdown } = useDocumentType();

  useEffect(() => {
    if (isOpen) fetchDocumentTypeDropdown();
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) cleanFormErrors();
  }, [isOpen]);

  const handleSubmit = () => {
    saveDocument();
  };

  return (
    <FormModal
      isOpen={isOpen}
      onClose={close}
      title="Habilitar Tipo de Documento"
      maxWidth="max-w-2xl"
    >
      <SectionInfoHeader
        icon={<HelpCircle className="text-white" />}
        title="Seleccione un Tipo de Documento"
        description="Habilita este tipo de documento para permitir su uso en procesos de emisión dentro del sistema."
      />

      <div className="mt-6 flex flex-col gap-6 px-1 pb-2">
        <SelectField
          label="Tipo de Documento"
          name="documentTypeId"
          value={form.documentTypeId ?? ''}
          onChange={(e) => updateField('documentTypeId', e.target.value)}
          options={documentTypeDropdown.map((d) => ({
            value: d.id,
            label: `${d.code} - ${d.name}`,
          }))}
          placeholder="Seleccione el documento que desea habilitar"
          error={formErrors.documentTypeId}
          iconKey="file"
          required
        />

        {/* ✅ Sección informativa */}
        <div className="bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300 flex items-start gap-3 rounded-md px-4 text-sm">
          <Info className="mt-0.5 h-5 w-5 flex-shrink-0 text-primary" />
          <p className="leading-relaxed">
            Los tipos de documento habilitados serán los únicos disponibles para
            su uso en emisión desde el sistema.
            <br />
            <br />
            Puedes habilitar únicamente los documentos necesarios para el giro
            comercial del contribuyente, evitando errores y simplificando la
            operación diaria.
            <br />
            <br />
            En cualquier momento podrás deshabilitar un documento si deja de
            utilizarse, sin afectar la información histórica ya registrada.
          </p>
        </div>

        <button
          onClick={handleSubmit}
          disabled={isSubmit}
          className={`w-full rounded bg-primary px-4 py-2 font-medium text-white transition hover:bg-opacity-90 
            ${isSubmit ? 'cursor-not-allowed opacity-50' : ''}`}
        >
          Guardar
        </button>
      </div>
    </FormModal>
  );
};

export default EnabledDocumentTypePopup;
